import { ContractUnilever, ContractUnileverStatement } from "../../../models/contract/ContractUnilever";
import { Harvest } from "../../../models/contract/Harvest";
import { Landplot } from "../../../models/organisation/Landplot";

export class LandPlotDashBoardModel {
    landPlot: Landplot
    contracts: ContractUnilever[] = []
    harvests: ContractUnileverStatement[]
    quantity: number = 0
    totalAmount: number = 0
    totalPpunch: number = 0
    totalFcrop: number = 0

    addInfo(harvest: ContractUnileverStatement, contract?: ContractUnilever) {
        if (contract) {
            this.contracts.push(contract)
        }
        this.quantity += harvest.quantity
        this.harvests.push(harvest)
    }

    addInfoExport(harvest: Harvest) {
        this.quantity += harvest.quantity
    }

    isUnileverLandPlot(): boolean {
        return this.landPlot.isPlotInProgram
    }

    constructor(landplot: Landplot) {
        this.landPlot = landplot
        this.contracts = []
        this.harvests = []
    }
}